import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class CategoryService {
	private db;
	categories: FirebaseListObservable<Category[]>;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadCategories();
	}

	/**
	 * Load initial data
	 */
	loadCategories() {
		window.dispatchEvent(new Event('loading'));
		this.categories = this.db.list('/categories') as FirebaseListObservable<Category[]>
		this.categories.subscribe(data => {
			this.triggerDataChange();
		});

		return this.categories;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All Categories
	 */
	getCategories() {
		return this.categories;
	}

	/**
	 * Get Category by ID
	 * @param {string} id : Item ID
	 */
	getCategory(id: string) {
		return this.db.object('/categories/' + id) as FirebaseObjectObservable<Category>;
	}

	/**
	 * Add new Category
	 * @param {Category} category
	 */
	addCategory(category) {
		return this.categories.push(category);
	}

	/**
	 * Update Category Data
	 * @param {string} id   : Item ID
	 * @param {object} data : Updated data
	 */
	updateCategory(id: string, data: Category) {
		var category = this.getCategory(id);
		data.updated_at = (new Date()).getTime();
		if (!data.created_at) {
			data.created_at = (new Date()).getTime();
		}
		return category.update(data);
	}

	/**
	 * Delete Category
	 * @param {string} id : Item ID
	 */
	deleteCategory(id: string) {
		if (!id) {
			return new firebase.Promise<void>((resolve, reject) => {
				reject(null);
			})
		}

		var result = this.categories.remove(id)
		this.triggerDataChange();
		return result;
	}
}

export class Category {
	$key?: string;
	name?: string = '';
	image?: string = '';
	description?: string = '';
	parent_id?: string = '';
	goes_to?: string = 'product';
	order_number?: string = '1';

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/category.service.ts